import {Injectable} from '@angular/core';
import {db} from '../db.service';
import {SecureTable} from '../secure.table';
import {VitalSignEntry} from '../../interfaces/vital-signs/vital-sign-entry';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {VitalSignEntryFactory} from '../../factories/vital-signs/vital-sign-entry-factory';


@Injectable({
  providedIn: 'root'
})
export class VitalSignEntriesTable extends SecureTable<VitalSignEntry> {
  constructor() {
    super(db.vitalSignEntries);

    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<VitalSignEntry>({
        api: ['vital-signs', 'entries'],
        fromObject: VitalSignEntryFactory.fromObject,
        toRemote: VitalSignEntryFactory.toRemote
      })
    };
  }

  public async removeByCustomerIds(customerIds: number[] = [], ): Promise<void> {
    if(customerIds.length === 0) {
      return;
    }

    const vitalSignEntries = await this.table
      .where('customerId')
      .anyOf(customerIds)
      .toArray();

    const uuidsToDelete = vitalSignEntries.map(vitalSignEntry => vitalSignEntry.uuid);

    if(uuidsToDelete.length > 0) {
      await this.removeMany(uuidsToDelete, true);
    }
  }

  public async getByCustomerId(customerId: number): Promise<VitalSignEntry[]> {
    return this.table
      .where('customerId')
      .equals(customerId)
      .toArray();
  }

}
